import React, { Component, ErrorInfo, ReactNode } from "react";

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  private handleReset = () => {
    // Purger les caches et recharger
    if ('caches' in window) {
      caches.keys().then((names) => {
        for (const name of names) caches.delete(name);
      });
    }
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/";
  };

  public render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6 font-nunito">
          <div className="max-w-md w-full bg-white rounded-[2.5rem] p-10 shadow-2xl text-center border border-red-100 animate-in zoom-in duration-300">
            <div className="w-20 h-20 bg-red-50 rounded-3xl flex items-center justify-center mx-auto mb-8">
              <i className="ri-error-warning-fill text-4xl text-red-500"></i>
            </div>
            <h1 className="text-2xl font-black text-gray-900 mb-4 font-playfair tracking-tight">Oups ! Quelque chose a mal tourné.</h1>
            <p className="text-gray-500 text-sm mb-10 leading-relaxed font-medium">
              L'application a rencontré une erreur inattendue. Ne vous inquiétez pas, vos données hors-ligne sont en sécurité.
            </p>
            
            <div className="space-y-3">
              <button
                onClick={() => window.location.reload()}
                className="w-full py-4 bg-gray-900 text-white rounded-2xl text-sm font-black hover:bg-black transition-all cursor-pointer shadow-xl active:scale-95 flex items-center justify-center gap-2"
              >
                <i className="ri-refresh-line"></i>
                RÉESSAYER
              </button>
              
              <button
                onClick={this.handleReset}
                className="w-full py-4 bg-white text-red-600 border-2 border-red-50 rounded-2xl text-sm font-black hover:bg-red-50 transition-all cursor-pointer flex items-center justify-center gap-2"
              >
                <i className="ri-delete-bin-line"></i>
                RÉINITIALISER L'APPLICATION
              </button>
            </div>
            
            <p className="mt-8 text-[10px] text-gray-300 font-bold uppercase tracking-widest">
              Si le problème persiste, contactez le support technique.
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
